<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import PrintOptions from "@/components/modals/print-options.vue";
import FundCluster from "./settings/fund-cluster";
import AccountClassification from "./settings/account-classification.vue";
import SubsidiaryLedgerTypes from "./settings/subsidiary-ledger-types.vue";
import TransactionTypes from "./settings/transaction-types.vue";

export default {
  page: {
    title: "Finance Settings",
  },
  components: {
    Layout,
    PageHeader,
    FundCluster,
    PrintOptions,
    AccountClassification,
    SubsidiaryLedgerTypes,
    TransactionTypes
  },
  data() {  
    return {
      title: "Finance Settings",
      submitted: false,
      items: [
        {
          text: "Dashboards",
          href: "/",
        },
        {
          text: "Finance Settings",
          active: true,
        },
      ],
    };
  },
  methods: {
    printAccounts() {
      this.$refs.printOpt.putOptions({
        apiUrl: "/api/Report/Finance/Accounts",
        routeVariables: [],
      });
      this.$bvModal.show("print-options-modal");
    },
    getSlCategories() {
      this.$refs.subsidiaryLedgerTypes.getSlCategories();
    },
    getTransactionTypes() {
      this.$refs.transactionTypes.getTransactionTypes();
    },
  },
};
</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <b-tabs
      pills
      vertical
      nav-class="p-0"
      nav-wrapper-class="col-sm-2"
      content-class="pt-0 px-2 text-muted"
    >
      <b-tab title-item-class="mb-2">
        <template v-slot:title>
          <span class="d-inline-block d-sm-none">
            <i class="bx bx-home"></i>
          </span>
          <span class="d-none d-sm-inline-block">Chart of Accounts</span>
        </template>
        <!-- <FundClassification @printAccounts="printAccounts" /> -->
        <AccountClassification @printAccounts="printAccounts" />
      </b-tab>
      <b-tab title-item-class="mb-2">
        <template v-slot:title>
          <span class="d-inline-block d-sm-none">
            <i class="bx bx-home"></i>
          </span>
          <span class="d-none d-sm-inline-block">Fund Cluster</span>
        </template>
        <FundCluster />
      </b-tab>
      <b-tab title-item-class="mb-2" @click="getSlCategories">
        <template v-slot:title>
          <span class="d-inline-block d-sm-none">
            <i class="bx bx-home"></i>
          </span>
          <span class="d-none d-sm-inline-block">Subsidiary Ledger Types</span>
        </template>
        <SubsidiaryLedgerTypes ref="subsidiaryLedgerTypes" />
      </b-tab>
      <b-tab title-item-class="mb-2" @click="getTransactionTypes">
        <template v-slot:title>
          <span class="d-inline-block d-sm-none">
            <i class="bx bx-home"></i>
          </span>
          <span class="d-none d-sm-inline-block">Transaction Types</span>
        </template>
        <TransactionTypes ref="transactionTypes" />
      </b-tab>
    </b-tabs>
    <print-options ref="printOpt"></print-options>
  </Layout>
</template>
